import "../UserAlarms/styles.css";
import { DismissNotifications, notificationDTO } from "./tenantApiCalls";
export interface userNotificationsProps {
    notifications: notificationDTO[];
    onClose: () => void;
    onNotificationClick: () => void;
}

interface notificationDataDTO {
    Subject: string;
    Body: string;
}

function parseNotificationData(data?: string): notificationDataDTO | undefined {
    if (!data) return undefined;
    try {
        return JSON.parse(data);
    } catch (error) {
        console.error("Error parsing notification data:", error);
        return undefined;
    }
}

function UserNotifications(props: userNotificationsProps) {
    async function handleNotificationClick(notification: notificationDTO) {
        await DismissNotifications([notification.notificationID]);
        props.onNotificationClick();
    }

    async function handleDismissAll() {
        await DismissNotifications(props.notifications.map(notification => notification.notificationID));
        props.onClose();
    }

    return (
        <div className="userAlarmsContainer">
            <div className="mainHeader">{"Notifications (" + props.notifications.length + ")"}</div>
            <div style={{ overflowY: "auto", height: "340px" }}>
                {props.notifications.length === 0 && <div className="userAlarms-body">No notifications</div>}
                {props.notifications.map(notification => {
                    const data = parseNotificationData(notification.data);
                    return (
                        <div
                            className="userAlarms-container"
                            key={notification.notificationID}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleNotificationClick(notification)}
                        >
                            <div className="userAlarms-body">
                                <div style={{ margin: "6px 0px 6px 0px" }}>
                                    <strong>{data?.Subject ?? `Notification #${notification.notificationID}`}</strong>
                                    {data?.Body && <div>{data.Body}</div>}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {props.notifications.length > 0 && (
                <div className="mainfooter">
                    <label onClick={handleDismissAll}>Dismiss All</label>
                </div>
            )}
        </div>
    );
}
export default UserNotifications;
